import { Checkbox } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountFilters } from '../../hooks/useAccountFilters'
import * as Styled from './styles'

export const AccountVoidedFilter = (): ReactElement => {
  const { t } = useTranslation()
  const [{ withVoided }, setQueryParams] = useAccountFilters()

  const handleChecked = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checked = event.target.checked

      setQueryParams({ withVoided: checked })
    },
    [setQueryParams],
  )

  return (
    <Styled.AccountVoidedFilterWrapper>
      <Checkbox name="withVoided" checked={withVoided} onChange={handleChecked}>
        {t('account_statements.show_voided')}
      </Checkbox>
    </Styled.AccountVoidedFilterWrapper>
  )
}
